<div class="task-expiration-container" *ngIf="!isLabelsLoading">
	<div class="header-wrap">
		<span class="tab selected">{{ labels.lbl_configuracao_aprovacao_tarefa }}</span>
	</div>
	<div class="body-wrap">
		<ng-container *ngIf="!isTaskExpirationLoading">
			<div class="search-container">
				<div class="content-container">
					<div class="table-container">
						<table>
							<thead>
								<tr>
									<th>{{ labels.lbl_prazo_expiracao }}</th>
									<th>{{ labels.lbl_bulletin_actions }}</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngIf="taskExpiration.length > 0">
									<tr class="select-bond" *ngFor="let item of taskExpiration; let indexItem = index">
										<td class="truncate-text" [title]="item.expirationTime">
											{{ convertToHours(item.expirationTime) }}
										</td>
										<td><fa-icon [icon]="icons.faPencil" (click)="openUpdatedForm(item)"></fa-icon></td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<div class="content-container" *ngIf="showEditForm">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_prazo_expiracao }}*</span>
					<select [(ngModel)]="selectedOption">
						<option [value]="null" disabled="disabled">{{ labels.lbl_geral_selecione }}</option>
						<option value="day">{{ labels.lbl_geral_dia }}</option>
						<option value="hour">{{ labels.lbl_geral_hora }}</option>
					</select>
				</div>

				<div class="dotted-input-container" *ngIf="selectedOption === 'hour'">
					<span>{{ labels.lbl_geral_hora }}</span>
					<input mask="Hh:m0" (change)="formUpdate.expirationTime = $event.target.value" [placeholder]="'00:00'" />
				</div>

				<div class="dotted-input-container" *ngIf="selectedOption === 'day'">
					<span>{{ labels.lbl_escalonamento_dia }}</span>
					<input mask="0*" (change)="formUpdate.expirationTime = $event.target.value" [placeholder]="'0'" />
				</div>

				<div class="button-container">
					<div class="button" [ngClass]="{ disabled: isUpdating }" (click)="saveModification(formUpdate.expirationTime)">
						{{ labels.lbl_geral_atualizar }}
						<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdating"></cpi-dot-bounce-loading-effect>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>

<cpi-dot-bounce-loading-effect
	class="mt-2 ml-2"
	*ngIf="isLabelsLoading || isTaskExpirationLoading"
	[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
